import { FC, PropsWithChildren } from 'react';
import cn from 'classnames';

import s from './container.module.scss';

type ContainerProps = { size?: 'sm' | 'lg'; className?: string };

export const Container: FC<PropsWithChildren<ContainerProps>> = ({
  size = 'lg',
  children,
  className
}) => {
  return <div className={cn(s[`container--${size}`], className)}>{children}</div>;
};
